'use client';

import { motion } from "framer-motion";
import { ContactForm } from "@/components/contact-form";
// import { ChatAssistant } from "@/components/chat-assistant"; // Temporarily disabled
import { Card } from "@/components/ui/card";
import { LocationMap } from "@/components/location-map";

export default function Contact() {
  return (
    <div className="container mx-auto max-w-6xl px-4 py-16 mt-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="space-y-12"
      >
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold tracking-tight">Contact Us</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Get in touch with our team or chat with our AI assistant
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          <Card className="p-6" style={{
            borderColor: '#8B5CF6'
          }}>
            <h2 className="text-2xl font-semibold mb-4">Send us a message</h2>
            <ContactForm />
          </Card>

          {/* Location Map and Social Media */}
          <LocationMap />

          {/* AI Chat Assistant temporarily removed
          <Card className="p-6" style={{
            borderColor: '#8B5CF6'
          }}>
            <h2 className="text-2xl font-semibold mb-4">Chat with AI Assistant</h2>
            <ChatAssistant />
          </Card>
          */}
        </div>
      </motion.div>
    </div>
  );
}